import { Accordion as MuiAccordion, styled } from '@mui/material';

export const Accordion = styled(MuiAccordion)({
  border: 'none',
  boxShadow: 'none',
  background: 'none',
  '&:not(:last-child)': { borderBottom: 0 },
  '&:before': { display: 'none' },
  '&.Mui-expanded': { margin: 'auto' },
});
